import { call, put } from 'typed-redux-saga'
import { api } from '../../../../../api/signalRApi'
import {
	StartFetchBankSessionsTransactionsAction,
	fetchBankSessionsTransactionsFailed,
} from '../../actions/consumerDataPullSessionActions/fetchBankSessionsTransactions'

export function* fetchBankSessionsTransactions(
	action: StartFetchBankSessionsTransactionsAction,
): Generator {
	try {
		yield* call(() =>
			api.fetchBankSessionsTransactions(
				action.deselectedAccountIds,
				action.calculationReferenceDate,
			),
		)
	} catch (err: any) {
		yield put(
			fetchBankSessionsTransactionsFailed({
				name: 'FatchBankTransactionsFailed',
				errorText: err.toString(),
				errorCode: '',
				data: undefined,
			}),
		)
		return
	}
}
